import React,{useEffect} from 'react'
import { Form, Input } from 'antd'
import { SafetyCertificateOutlined } from '@ant-design/icons'


export default function IDasImageCaptcha(props) {
    const { handleClick, captchaId, captchaImg,form,style } = props
    const codeValidate = (rule,value,callback)=> {
        if(!value || value.trim() === ""){
            callback("请输入图片验证码");
            return;
        }
        callback();
    }
    useEffect(()=> {

    })
    return (
        <div id='imageCode'>
            <Form.Item name="ImgCodeId" hidden={true}><Input/></Form.Item>
            <Form.Item name="ImgCode" hasFeedback={true} style={style}
                       rules={[{required: true, validator:(rule,value,callback)=>codeValidate(rule,value,callback),},]}>
                <Input maxLength={4} prefix={<SafetyCertificateOutlined className="site-form-item-icon" />} placeholder="图片验证码" />
            </Form.Item>
            <div onClick={handleClick}>
                <img src={captchaImg} alt="点击刷新图片验证码" />
            </div>
        </div>
    )
}
